import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "desTitle"
};
const _hoisted_3 = {
  class: "erWeiMaCode",
  ref: "erWeiMaCode"
};
const _hoisted_4 = {
  class: "erWeiMaName"
};
const _hoisted_5 = {
  key: 2,
  class: "h5Img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "otherDatas"
};
const _hoisted_9 = {
  class: "swiper-container",
  ref: "swipercontainer"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "nav_list",
  id: "nav_list"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 5,
  class: "descContent"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  key: 6,
  id: "voice",
  ref: "voice",
  preload: "auto"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 7,
  id: "video",
  preload: "",
  controls: "",
  autoplay: "",
  loop: "",
  style: {
    "opacity": "0"
  },
  "webkit-playsinline": "true",
  playsinline: "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lsDetailScript = _resolveComponent("lsDetailScript");
  const _component_lsDetail = _resolveComponent("lsDetail");
  const _component_mobile = _resolveComponent("mobile");
  const _component_hysbwg = _resolveComponent("hysbwg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`new3DDetail ${$data.isMobile ? 'h5' : ''} ${_ctx.$route.query.type || 'white'} ${_ctx.$route.query.fy ? 'gzfy' : ''} d_${_ctx.$route.query.fid}`),
    ref: "new3DDetail"
  }, [!_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toIndex && $options.toIndex(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.columns.length < 9 ? 'padding-left: 10px' : '')
  }, [$data.config.logo ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.config.logo
  }, null, 8, _hoisted_1)) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_2, [$data.columns.length > 1 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(`column_${$data.columns.findIndex(c => {
      return c.columnName == $data.detail.columnName;
    })}`)
  }, _toDisplayString($data.detail.columnName), 3)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString($data.detail.name), 1)]), !$data.isMobile ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "code",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clickErCode && $options.clickErCode(...args))
  }, [!$data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`erWeiMa ${$data.showBigErCode ? '' : 'activeSmallEr'}`)
  }, "二维码", 2)) : _createCommentVNode("", true), $data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`erWeiMaBig ${!$data.showBigErCode ? 'hideEr' : 'activeEr'}`)
  }, [_createElementVNode("div", _hoisted_3, null, 512), _createElementVNode("div", _hoisted_4, [_cache[7] || (_cache[7] = _createTextVNode("扫一扫")), _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)), _createTextVNode("3D" + _toDisplayString(_ctx.$route.query.fid == 30015 ? '藏品' : '文物') + "带回家", 1)])], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.showModels[0] && $data.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_6)])) : _createCommentVNode("", true), _createVNode(_component_lsDetailScript), $data.showDetail ? (_openBlock(), _createBlock(_component_lsDetail, {
    key: 3,
    class: _normalizeClass({
      'hidetransparency': $data.showModels[0] && $data.isMobile
    }),
    detailCode: $data.detailCode,
    showModels: $data.showModels,
    isMobile: $data.isMobile,
    ref: "lsDetail",
    activeIndex: $data.activeIndex,
    onSetParent: $options.setParent
  }, null, 8, ["class", "detailCode", "showModels", "isMobile", "activeIndex", "onSetParent"])) : _createCommentVNode("", true), $data.detail.hasNoFile ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: _normalizeClass({
      'hidetransparency': $data.showModels[0] && $data.isMobile,
      'noFileImg': true
    }),
    onClick: _cache[2] || (_cache[2] = $event => $options.handelShowBigImg($data.detail.img))
  }, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_7)], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "btnTurnLeft"
  }, null, -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`swiper-slide ${item.code == this.detailCode && (item.type == this.detail.type || _ctx.$route.query.fid == 328720) ? 'activeDetail' : ''}`),
      onClick: $event => $options.clickDetail(index, item.m_index)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_12)], 10, _hoisted_11);
  }), 256))])], 512), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "btnTurnRight"
  }, null, -1))], 512), [[_vShow, !$data.isMobile && !_ctx.$route.query.hideOthers]]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: _normalizeClass(`nav_item icon_1 ${$data.showModels[0] ? 'active' : ''}`),
    onClick: _cache[3] || (_cache[3] = $event => $options.showModel(0))
  }, _cache[11] || (_cache[11] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, null, -1)]), 2), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(`nav_item icon_2 ${$data.showModels[1] ? 'active' : ''}`),
    onClick: _cache[4] || (_cache[4] = $event => $options.showModel(1))
  }, _cache[12] || (_cache[12] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, null, -1)]), 2), [[_vShow, $data.detail.zhuanti]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`nav_item ${$data.showModels[2] ? 'icon_3_a' : 'icon_3'}`),
    id: "radio",
    onClick: _cache[5] || (_cache[5] = $event => $options.showModel(2))
  }, [_cache[13] || (_cache[13] = _createElementVNode("i", null, null, -1)), $data.showModels[2] ? (_openBlock(), _createElementBlock("span", _hoisted_14, "语音介绍")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]), $data.showModels[0] ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", {
    class: "description",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_16), _createElementVNode("div", {
    class: "closeDesc",
    onClick: _cache[6] || (_cache[6] = $event => $options.showModel(0))
  })])) : _createCommentVNode("", true), $data.detail.audio ? (_openBlock(), _createElementBlock("audio", _hoisted_17, [_createElementVNode("source", {
    src: $data.detail.audio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_18)], 512)) : _createCommentVNode("", true), _ctx.$route.query.fid == 200090 && _ctx.$route.query.code == '000045' ? (_openBlock(), _createElementBlock("video", _hoisted_19)) : _createCommentVNode("", true), _createVNode(_component_mobile), _createVNode(_component_hysbwg, {
    name: "new3DDetail"
  })], 2);
}